// src/pages/MyBookingPage.jsx
import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import MyProperties from "../components/MyProperties";
import RevenueSubscriptionSection from "../components/revenue/RevenueSubscriptionSection";

const SubscriptionPage = () => {
  return (
    <>
      <Header />
      <RevenueSubscriptionSection />
      <Footer />
    </>
  );
};

export default SubscriptionPage;
